import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { COUNTER_ENDPOINT } from '../../config';

export const PIXEL_ACTIONS = {
    VIEW: 'view',
    OPEN: 'open',
    BOOKING_ATTEMPT: 'booking_attempt',
    BOOKED: 'booked',
    PURCHASE_ATTEMPT: 'purchase_attempt',
    WIDGET_OPEN_SELECTOR: 'widget_open_selector',
    WIDGET_OPEN_USERINFO: 'widget_open_userinfo',
    WIDGET_CHECK_ORDER: 'widget_check_order',
    WIDGET_CLOSE: 'widget_close',
    VIEW_PURCHASE_REFUSED_PAGE: 'view_purchase_refused_page',
    VIEW_TICKETS_PAGE: 'view_tickets_page',
    VIEW_RULES: 'view_rules',
    WIDGET_VIEW_RULES: 'widget_view_rules',
    VIEW_PUBLIC_OFFER: 'view_public_offer',
    WIDGET_VIEW_PUBLIC_OFFER: 'widget_view_public_offer',
    WIDGET_PURCHASE_ATTEMPT: 'widget_purchase_attempt',
}

class Pixel extends Component {

    render() {
        const pixelParams = filterPixelParams({
            ...getPixelParams(),
            event_id: this.props.eventId || null,
            performance_id: this.props.performanceId || null,
            order_id: this.props.orderId || null,
            action: this.props.action || null,
        })
        const pixelUrl = getPixelUrl(pixelParams)

        return <img src={pixelUrl} alt="" style={{display: 'block', height: '0px'}} />
    }
}

Pixel.propTypes = {
    eventId: PropTypes.string,
    performanceId: PropTypes.string,
    orderId: PropTypes.string,
    action: PropTypes.oneOf(Object.values(PIXEL_ACTIONS))
}

export function callPixel(newPixelParams) {
    const pixelParams = {
        ...getPixelParams(),
        ...newPixelParams
    }
    const pixelUrl = getPixelUrl(pixelParams)
    fetch(pixelUrl)
}

function getPixelParams() {
    const sourcePageUrl = getSourcePageUrl()
    const documentUrl = new URL(document.location.href)
    let referrerUrl = getReferrer()
    return filterPixelParams({
        source: documentUrl.searchParams.get('utm_source') || referrerUrl.searchParams.get('utm_source'),
        campaign: getCampaign(documentUrl, referrerUrl),
        medium: documentUrl.searchParams.get('utm_medium') || referrerUrl.searchParams.get('utm_medium'),
        content: documentUrl.searchParams.get('utm_content') || referrerUrl.searchParams.get('utm_content'),
        url: sourcePageUrl
    })
}

function getPixelUrl(pixelParams) {
    return `${COUNTER_ENDPOINT}/pixel.gif?${new URLSearchParams(pixelParams).toString()}`
}

function filterPixelParams(pixelParams) {
        Object.keys(pixelParams).forEach(key => {
            if (!pixelParams[key] || !pixelParams[key].trim().length) {
                delete pixelParams[key]
            }
        })
        return pixelParams
}

function getReferrer() {
    const documentUrl = new URL(document.location.href)
    let referrerUrl = documentUrl
    if (document.referrer) {
        referrerUrl = new URL(document.referrer)
    }
    return referrerUrl
}

function getCampaign(documentUrl, referrerUrl) {
    return (
        // Explicitly passed UTM-campaign, even if in iframe
        documentUrl.searchParams.get('utm_campaign') ||
        // or UTM-campaign param in referrer url
        referrerUrl.searchParams.get('utm_campaign') ||
        // or fragment of url
        documentUrl.hash.slice(1)
    )
}

function getSourcePageUrl() {
    return isInIframe() ? document.referrer : document.location.href
}

function isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export default Pixel;
